import script from "./Paid.vue?vue&type=script&lang=ts&setup=true"
export * from "./Paid.vue?vue&type=script&lang=ts&setup=true"

import "./Paid.vue?vue&type=style&index=0&id=255d231e&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255d231e"]])

export default __exports__